import { type FC } from "react";

import { FilterDropdown } from "~/components/UI/FilterDropdown";
import { useCategoryFilterDropdownOptions } from "~/feature/dashboard/components/sortAndFilters/CategoryFilterDropdown/useCategoryFilterDropdownOptions";

import { useCategoryFilterDropdown } from "./useCategoryFilterDropdown";

export const CategoryFilterDropdown: FC = () => {
  const options = useCategoryFilterDropdownOptions();
  const { selectedValue, onChangeCategoryFilter } = useCategoryFilterDropdown();

  return (
    <FilterDropdown
      label="Category"
      options={options}
      defaultValue="All"
      value={selectedValue}
      onChange={onChangeCategoryFilter}
    />
  );
};
